import { render } from "./EventParent.vue?vue&type=template&id=5afd875e"
import script from "./EventParent.vue?vue&type=script&lang=js"
export * from "./EventParent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__